import { TimeSignal } from 'graphql/types';

export interface GroupDurationStrategy {
  calculate: (notes: TimeSignal[]) => number;
}

export class GroupDurationCalculator {
  constructor(private strategy: GroupDurationStrategy) {}

  calculate(notes: TimeSignal[]): number {
    return this.strategy.calculate(notes);
  }
}
